import type { ResumeExperience } from 'types/resume';
import ExperienceCard from '../ExperienceCard';
import styles from './ExperienceSection.module.scss';

interface Props {
  roles: ResumeExperience[];
}

export default function ExperienceSection({ roles }: Props) {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Experience</h2>
      <div className={styles.timeline}>
        <div className={styles.timelineLine} />
        <div className={styles.cards}>
          {roles.map(role => (
            <ExperienceCard key={role.slug} role={role} />
          ))}
        </div>
      </div>
    </section>
  );
}
